/* eslint-disable no-console */
<template>
    <div>
        <div class="header_unit header_bg_white">
            <div class="header_box">
                <div class="menu_left">
                    <router-link class="icn_back_black top_tit" :to="{ name: 'cookingCheckInput', params: {menuId:menuId,subMenuId:subMenuId}} ">
                        <p class="top_tit">＜戻る</p></router-link>
                </div>
                <div class="menu_center">
                    <p class="menu_center_tex_l top_tit">調理名登録画面</p>
                </div>
            </div>
        </div>
        <StoreTyoriSetting :menu-id="menuId"
                           :sub-menu-id="subMenuId"/>
    </div>

</template>

<script>
    import StoreTyoriSetting from '@/app/components/StoreTyoriSetting.vue'
    export default {
        name: 'manageStoreTyoriSetting',
        components: {
          StoreTyoriSetting
        },
        props: {
          menuId: {
            type: Number,
            require: true
          },
          subMenuId: {
            type: Number,
            require: true
          },
        }
    }
</script>
